export default {
      id: "siglevel-client-approval-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#siglevel-client-approval",
      toString: function () {
        return this.url;
      }
    }